import React from "react";

const ContactIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 1.375C3.44568 1.375 1.375 3.44568 1.375 6C1.375 7.19669 1.82949 8.28722 2.57528 9.10841C3.00655 8.51292 3.70769 8.125 4.5 8.125H7.5C8.29231 8.125 8.99345 8.51292 9.42472 9.10841C10.1705 8.28723 10.625 7.19669 10.625 6C10.625 3.44568 8.55432 1.375 6 1.375ZM9.59921 9.99209C10.6896 9.00837 11.375 7.58422 11.375 6C11.375 3.03147 8.96853 0.625 6 0.625C3.03147 0.625 0.625 3.03147 0.625 6C0.625 7.58422 1.31038 9.00836 2.40079 9.99209C2.40509 9.99614 2.40949 10.0001 2.414 10.004C3.36526 10.8565 4.62208 11.375 6 11.375C7.37792 11.375 8.63474 10.8565 9.586 10.004C9.59051 10.0001 9.59491 9.99615 9.59921 9.99209ZM8.87063 9.62655C8.58176 9.17424 8.07551 8.875 7.5 8.875H4.5C3.92449 8.875 3.41824 9.17424 3.12937 9.62654C3.91806 10.2517 4.91544 10.625 6 10.625C7.08456 10.625 8.08193 10.2517 8.87063 9.62655ZM6 3.125C5.10254 3.125 4.375 3.85254 4.375 4.75C4.375 5.64746 5.10254 6.375 6 6.375C6.89746 6.375 7.625 5.64746 7.625 4.75C7.625 3.85254 6.89746 3.125 6 3.125ZM3.625 4.75C3.625 3.43832 4.68832 2.375 6 2.375C7.31168 2.375 8.375 3.43832 8.375 4.75C8.375 6.06168 7.31168 7.125 6 7.125C4.68832 7.125 3.625 6.06168 3.625 4.75Z"
        fill="#6E00BE"
      />
    </svg>
  );
};

export default ContactIcon;
